import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'B10',
      mockup: (
        <g id="b10" transform="translate(206.000000, 281.000000)">
          <polygon
            id="fill-b10"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="8.87918878 0.484949829 6.18043498 19.0163926 14.2766964 19.0163926 14.2766964 34.3093309 0.962844284 34.3093309 0.962844284 64.7152904 3.84151501 64.7152904 3.84151501 69.7529642 5.46076729 69.7529642 5.46076729 71.3722165 54.0383358 71.3722165 54.0383358 0.484949829"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="24.5879021" y="32.6194394">
              01
            </tspan>
          </text>
          <text
            id="B10"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="20.1099021" y="49.3917363">
              B10
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH4',
      mockup: (
        <g id="th4" transform="translate(40.000000, 364.000000)">
          <polygon
            id="fill-th4"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.6988399 11.6414715 57.9331905 11.6414715 57.9331905 0.0668163011 40.6611662 0.0668163011 40.6611662 1.68606858 0.359775977 1.68606858 0.359775977 73.4729198 30.0460678 73.4729198 30.0460678 57.4603139 45.6988399 57.4603139"
          />
          <text
            id="TH4"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="11.3726743" y="34.1419398">
              TH4
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH5',
      mockup: (
        <g id="th5" transform="translate(83.000000, 364.000000)">
          <polygon
            id="fill-th5"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.8189285 0.126788608 14.9331905 0.126788608 14.9331905 11.6414715 2.69883992 11.6414715 2.69883992 57.5202862 0.359919957 57.5202862 0.359919957 73.5328921 30.3460734 73.5328921 30.3460734 57.4603139 45.8189285 57.4603139"
          />
          <text
            id="TH5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.8930399" y="34.1419398">
              TH5
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH6',
      mockup: (
        <g id="th6" transform="translate(126.000000, 364.000000)">
          <polygon
            id="fill-th6"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.8190725 0.126788608 2.6989839 0.126788608 2.6989839 57.4603139 0.360063937 57.4603139 0.360063937 73.4729198 30.3462173 73.4729198 30.3462173 57.4603139 45.729114 57.4603139"
          />
          <text
            id="TH6"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.1316884" y="34.1419398">
              TH6
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH7',
      mockup: (
        <g id="th7" transform="translate(169.000000, 364.000000)">
          <polygon
            id="fill-th7"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.6392996 0.126788608 2.72911404 0.126788608 2.72911404 57.4603139 0.570110991 57.4603139 0.570110991 73.4729198 30.5562644 73.4729198 30.5562644 57.4603139 45.5493411 57.4603139"
          />
          <text
            id="TH7"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.3843275" y="34.1419398">
              TH7
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH8',
      mockup: (
        <g id="th8" transform="translate(212.000000, 364.000000)">
          <polygon
            id="fill-th8"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.9992774 0.126788608 2.51935494 0.126788608 2.51935494 57.4603139 0.540268817 57.4603139 0.540268817 73.4729198 30.5264222 73.4729198 30.5264222 57.4603139 45.9992774 57.4603139"
          />
          <text
            id="TH8"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.2799021" y="34.1419398">
              TH8
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH9',
      mockup: (
        <g id="th9" transform="translate(257.000000, 367.000000)">
          <polygon
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="43.1598091 0.125403948 0.879332763 0.125403948 0.879332763 54.4603139 15.8724095 54.4603139 15.8724095 70.4729198 43.2197814 70.4729198"
          />
          <text
            id="TH9"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="11.3455571" y="31.1419398">
              TH9
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH1',
      mockup: (
        <g id="th1" transform="translate(360.000000, 186.000000)">
          <polygon
            id="fill-th1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.971728162 68.3174948 43.4321214 68.3174948 43.4321214 44.0287106 43.2522045 44.0287106 43.2522045 16.3215048 30.2981862 16.3215048 30.2981862 0.308898928 0.312032787 0.308898928 0.312032787 33.2936677 1.03170047 33.2936677"
          />
          <text
            id="TH1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.1680771" y="41.2648939">
              TH1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH2',
      mockup: (
        <g id="th2" transform="translate(403.000000, 186.000000)">
          <polygon
            id="fill-th2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.151933 16.3215048 30.4782471 16.3215048 30.4782471 0.308898928 0.492093688 0.308898928 0.492093688 16.3215048 0.312176767 16.3215048 0.312176767 44.0287106 0.492093688 44.0287106 0.492093688 68.3174948 44.2119053 68.3174948"
          />
          <text
            id="TH2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.282627" y="41.2648939">
              TH2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH3',
      mockup: (
        <g id="th3" transform="translate(446.000000, 186.000000)">
          <polygon
            id="fill-th3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.0516616 16.3215048 30.4783911 16.3215048 30.4783911 0.308898928 0.492237668 0.308898928 0.492237668 16.3215048 1.21190535 16.3215048 1.21190535 68.3174948 45.1116339 68.3174948"
          />
          <text
            id="TH3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.117465" y="41.2648939">
              TH3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH13',
      mockup: (
        <g id="th13" transform="translate(437.000000, 364.000000)">
          <polygon
            id="fill-th13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="65.2065107 10.1421638 45.5955664 10.1421638 45.5955664 0.426650142 2.23558854 0.426650142 2.23558854 57.4003416 0.43641934 57.4003416 0.43641934 73.4129475 30.4225727 73.4129475 30.4225727 57.4603139 43.5864941 57.4603139 43.5864941 40.9079572 65.1765245 40.9079572"
          />
          <text
            id="TH13"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.1090746" y="34.1419398">
              TH13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH10',
      mockup: (
        <g id="th10" transform="translate(312.000000, 361.000000)">
          <polygon
            id="fill-th10"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.154270422 6.12540395 0.154270422 76.4729198 27.6515731 76.4729198 27.6515731 60.4603139 41.6850929 60.4603139 41.6850929 34.7321943 39.5260898 34.7321943 39.5260898 1.98731478 39.3461729 1.98731478 39.3461729 0.547979415 4.53224882 0.547979415 4.53224882 6.12540395"
          />
          <text
            id="TH10"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="7.01768165" y="37.1419398">
              TH10
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH11',
      mockup: (
        <g id="th11" transform="translate(351.000000, 362.000000)">
          <polygon
            id="fill-th11"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.2354446 2.42665014 26.3441679 2.42665014 26.3441679 0.987314779 0.43613138 0.987314779 0.43613138 33.7321943 2.59513443 33.7321943 2.59513443 59.4603139 16.0889035 59.4603139 16.0889035 75.4729198 45.2354446 75.4729198"
          />
          <text
            id="TH11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="9.41003279" y="36.1419398">
              TH11
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'TH12',
      mockup: (
        <g id="th12" transform="translate(396.000000, 364.000000)">
          <polygon
            id="fill-th12"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="43.2355885 0.426650142 0.235444564 0.426650142 0.235444564 73.4729198 28.1225672 73.4729198 28.1225672 57.4603139 43.1156439 57.4603139"
          />
          <text
            id="TH12"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="5.51827978" y="34.1419398">
              TH12
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <g
        id="streets"
        transform="translate(300.000000, 313.000000)"
        fill="#0B1A27"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
      >
        <text id="CLARKSON-ST">
          <tspan x="0" y="170.966278">
            CLARKSON ST
          </tspan>
        </text>
        <text
          id="SIXTH-ST"
          transform="translate(303.822589, 20.500000) rotate(-90.000000) translate(-303.822589, -20.500000) "
        >
          <tspan x="283.322589" y="24.5">
            SIXTH ST
          </tspan>
        </text>
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
      <g
        id="bg-shapes"
        transform="translate(40.000000, 163.000000)"
        stroke="#0B1A27"
        strokeWidth="0.5"
      >
        <path
          d="M462.229614,278.955688 L464.229614,278.955688"
          id="Line"
          strokeLinecap="square"
          fillRule="nonzero"
        />
        <polyline
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="443.183905 224.627762 438.27756 258.4903 438.27756 282.239334 463.286012 282.239334 463.286012 278.970843 472.641692 278.970843 472.641692 240.648539 480.737953 240.648539 480.737953 194.949641 471.02244 194.949641 471.02244 188.95241 448.352908 188.95241"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="345.620346"
          y="104.811264"
          width="102.732562"
          height="84.2011188"
        />
        <path
          d="M168.042346,152.309331 L168.042346,136.116808 L172.180435,136.116808 M542.26954,253.782474 L542.26954,220.797705"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="0.359775977 202.686069 40.6611662 202.686069 40.6611662 187.752964 42.8201692 187.752964"
        />
        <path
          d="M28.4268156,191.351303 L12.5941266,191.351303 M28.4268156,180.016537 L28.4268156,202.686069 M12.5941266,180.016537 L12.5941266,202.686069"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="260.519643"
          y="113.80711"
          width="16.5523567"
          height="62.2512545"
        />
        <path
          d="M260.669574,133.957805 L277.22193,133.957805 M260.669574,155.188002 L277.22193,155.188002"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M250.984046,162.204761 L250.984046,128.830173 M240.728782,162.204761 L260.669574,162.204761 M240.728782,128.830173 L260.669574,128.830173"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M277.072,176.058364 L260.519643,155.068057 L277.072,133.83786 L260.669574,113.837096 M260.669574,176.088351 L277.22193,155.098043 L260.669574,133.957805 L277.072,113.837096"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M462.206511,278.970843 C462.206511,278.970843 462.206511,266.616548 462.206511,241.907957 C462.206511,266.616548 462.206511,278.970843 462.206511,278.970843 Z"
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polygon
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="345.620346 104.84125 291.825187 104.84125 291.825187 176.058364 294.164107 176.058364 294.164107 186.313629 345.620346 186.313629"
        />
        <polygon
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="260.669574 113.837096 240.548865 113.837096 240.548865 176.058364 260.669574 176.058364"
        />
        <path
          d="M451.411495,254.142308 L451.411495,269.765094 M440.586494,254.142308 L462.176525,254.142308 M438.187602,269.79508 L462.176525,269.79508"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="448.352908 104.84125 451.051662 104.84125 451.051662 91.347481"
        />
        <polyline
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="42.8201692 187.752964 42.8201692 180.016537 0.359775977 180.016537 0.359775977 202.686069"
        />
        <polyline
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="212.301908 56.4136123 183.515201 56.4136123 174.879189 118.48495 220.038336 118.48495 220.038336 131.438968 240.548865 131.438968 240.548865 100.133424 226.695262 100.133424 226.695262 76.5643074"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="442.595566"
          y="204.665155"
          width="19.6109443"
          height="6.47700914"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="213.38141"
          y="274.47292"
          width="8.63601218"
          height="20.5105289"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="202.586395"
          y="285.088018"
          width="10.7950152"
          height="7.73642758"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="222.017422"
          y="285.088018"
          width="10.4351814"
          height="7.73642758"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="162.644838"
          y="285.088018"
          width="10.7950152"
          height="7.73642758"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="119.644694"
          y="285.088018"
          width="10.6150983"
          height="7.73642758"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="76.4646333"
          y="285.088018"
          width="10.7950152"
          height="7.73642758"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="33.4644893"
          y="285.088018"
          width="10.6150983"
          height="7.73642758"
        />
        <path
          d="M272.034326,274.47292 L272.034326,294.983449 L298.302196,294.983449 L298.302196,285.088018 L309.097211,285.088018 L309.097211,292.824446 L298.302196,292.824446 L298.302196,285.088018 M260.159809,274.47292 L260.159809,294.983449 L232.63252,294.983449 L232.63252,285.088018 M217.879333,274.47292 L217.879333,258.460314 M173.439853,274.47292 L173.439853,294.983449 L202.586395,294.983449 L202.586395,285.088018 M130.259793,274.47292 L130.259793,294.983449 L162.644838,294.983449 L162.644838,285.088018 M87.2596485,274.47292 L87.2596485,294.983449 L119.734653,294.983449 L119.734653,285.088018 M44.1695461,274.47292 L44.1695461,294.983449 L76.5545918,294.983449 L76.5545918,285.088018 M1.07944366,274.47292 L1.07944366,294.983449 L33.4644893,294.983449 L33.4644893,292.824446"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="309.097211"
          y="274.47292"
          width="8.45609526"
          height="20.5105289"
        />
        <path
          d="M313.595134,274.47292 L313.595134,258.460314"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="317.553307"
          y="285.088018"
          width="10.7950152"
          height="7.73642758"
        />
        <path
          d="M356.235445,274.47292 L356.235445,294.983449 M328.348322,292.824446 L328.348322,294.983449 L389.160241,294.983449 L389.160241,285.088018"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="389.160241"
          y="285.088018"
          width="10.6150983"
          height="7.73642758"
        />
        <path
          d="M439.177145,282.209347 L439.177145,294.983449 L445.474237,294.983449 L445.474237,282.209347 M399.775339,274.47292 L399.775339,294.983449 L426.58296,294.983449 L426.58296,285.088018 L439.177145,285.088018 L439.177145,292.824446 L426.58296,292.824446 L426.58296,285.088018"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M241.628366,76.5643074 L241.628366,56.4136123 M277.072,101.392842 L277.072,88.618741 L267.71632,88.618741 M320.971728,56.4136123 L237.010499,56.4136123 L237.010499,51.1960216 L212.301908,51.1960216 L212.301908,76.5643074 L267.71632,76.5643074 L267.71632,101.392842 L277.072,101.392842 L277.072,113.837096 L291.825187,113.837096 M177.398026,100.133424 L226.695262,100.133424 M42.8201692,187.752964 L169.841515,187.752964 M272.034326,211.322081 L260.039864,211.322081 M272.034326,263.318071 L260.039864,263.318071"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          id="Rectangle-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="246.486123"
          y="188.112798"
          width="17.4519413"
          height="6.11717529"
        />
        <path
          d="M333.74583,104.84125 L333.74583,91.347481 M320.971728,91.347481 L291.825187,91.347481 L291.825187,104.84125 M246.486123,188.112798 L246.486123,176.118337 M220.038336,189.432189 L246.486123,189.432189"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M406.432265,23.3088989 L406.432265,0.459450035 L436.418419,0.459450035 L436.418419,7.11637609 L449.19252,7.11637609 L449.19252,0.639366955 L436.418419,0.639366955 L436.418419,7.11637609 M363.372149,23.3088989 L363.372149,0.459450035 L393.598192,0.459450035 L393.598192,7.11637609 L406.372293,7.11637609 L406.372293,0.639366955 L393.598192,0.639366955 L393.598192,7.11637609 M321.27159,23.3088989 L321.27159,0.459450035 L350.628034,0.459450035 L350.628034,7.11637609 L363.402135,7.11637609 L363.402135,0.639366955 L350.628034,0.639366955 L350.628034,7.11637609"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M480.737953,194.949641 L480.737953,194.229973 L529.855273,194.229973 L529.855273,200.796941 L535.852503,200.796941 L535.852503,201.876442 M471.562191,278.970843 L471.562191,283.108932 L483.25679,283.108932 L483.25679,282.209347 L486.495295,280.770012 L530.934774,280.770012 L534.533113,282.209347 L534.533113,283.108932 L542.26954,283.108932 L542.26954,215.790018 L535.972448,215.790018 L535.972448,201.786484 L542.26954,201.786484 L542.26954,124.602125 L535.792531,124.602125 L535.792531,108.949353 L542.26954,108.949353 L542.26954,104.991181 L537.05195,104.991181 L537.05195,79.0831443 L542.26954,79.0831443 L542.26954,23.3088989 L530.934774,22.4093143 L531.474525,21.8695636 L523.01843,13.5933852 L522.118845,14.6728867 L521.549108,6.75654225 L521.908942,6.75654225 L521.549108,2.88832846 L449.252492,2.88832846 L449.252492,39.3215048"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M537.05195,104.811264 L451.051662,104.811264"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M267.71632,101.392842 L240.548865,101.392842"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M291.825187,113.837096 L277.072,88.6487272 L291.825187,91.347481 M291.825187,91.347481 L277.072,113.837096"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M322.411064,104.811264 L322.411064,91.3174948"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M305.139039,104.811264 L305.139039,91.3174948"
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          id="Shape"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="190.352044 118.48495 190.352044 109.12927 220.038336 109.12927 220.038336 118.48495"
        />
      </g>
      <text
        id="AMENITY"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
        fill="#0B1A27"
      >
        <tspan x="338.312033" y="312.619439">
          AMENITY
        </tspan>
      </text>
      <text
        id="LEVEL-2"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="303.972" y="597.839844">
          LEVEL 2
        </tspan>
      </text>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level2.js